export default __webpack_public_path__ + "static/download_ios-21b5db6c7e9976c5faf17809f2745da2.png";